module.exports = "<div id=\"flow-container\" *ngIf=\"flowUrl\">\r\n    <iframe id=\"iframe\" allowtransparency=\"true\" \r\n    [src]=\"flowUrl\"\r\n    frameborder=\"0\"></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/flow-preview/flow-preview.component.html
// module id = ../../../../../src/app/private/product/flow-preview/flow-preview.component.html
// module chunks = main